// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1Ypew","question":"Question_question__2zyS-","description":"Question_description__18MZ4"};